<template>
  <v-container fluid class="max-width docForm">
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Warehouse Release Orders</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text @click="generatePdf">
          <v-icon left color="accent">mdi-printer</v-icon> Generate Combined Order
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-btn color="primary" class="mt-2" small to="/new-warehouse-order">
            <v-icon left dark>mdi-plus</v-icon>Create New Order
          </v-btn>
        </v-row>

        <v-row>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
            hide-details></v-text-field>
        </v-row>

        <v-row class="subtitle-2 text--primary">
          <v-col cols="12" sm="12" md="12">
            <!-- start of table -->
            <v-data-table :headers="headers" :items="recordsData" :search="search" :mobile-breakpoint="0">
              <template v-slot:item.DocTotal="{ item }">
                <span>{{ item.DocTotal.toLocaleString() }}.00</span>
              </template>

              <template v-slot:item.DocNum="{ item }">
                <span>WR-{{ item.DocNum }}</span>
              </template>

              <template v-slot:item.CreatedAt="{ item }">
                <span>{{ item.CreatedAt | date }}</span>
              </template>

              <template v-slot:item.ConfirmationStatus="{ item }">
                <span style="color: red" v-if="item.ConfirmationStatus == 0">Pending Confirmation</span>
                <span style="color: green" v-if="item.ConfirmationStatus == 1">Confirmed</span>
              </template>


              <template v-slot:item.action="{ item }">
                <v-btn text :to="`/warehouse-order/${item.id}`" color="accent">
                  <v-icon left>mdi-eye</v-icon> Details
                </v-btn>
              </template>
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <snackbar ref="snackbar"></snackbar>

     <!-- pdf preview -->
     <pdf-preview ref="pdfPreview"></pdf-preview>
    <!-- end -->

  </v-container>
</template>

<script>
import { http, host } from "@/common/index";
export default {
  data: () => ({
    search: "",
    date: new Date().toISOString().substr(0, 10),
    headers: [
      { text: "Doc No.", value: "DocNum" },
      { text: "Customer", value: "customer.Name" },
      { text: "Created By", value: "user.name" },
      { text: "Status", value: "ConfirmationStatus" },
      { text: "Date", value: "CreatedAt" },
      { text: "View Details", value: "action" },
    ],
    recordsData: [],
  }),
  methods: {
    generatePdf() {
      var url = "/generate-combined-warehouse-order";
      const apiUrl = `${host}${url}`;
      const self = this;
      http.get(apiUrl, { responseType: "blob" }).then(response => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        var fileUrl = URL.createObjectURL(blob);
        self.$refs.pdfPreview.show(fileUrl);
      });
    },
    getRecords() {
      let data = {};
      data.StartDate = this.date;
      const self = this;
      const url = `/get-warehouse-orders`;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("get", url)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.recordsData = res.ResponseData;
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
            self.$store.commit("loader", false);
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getRecords();
  },
};
</script>